

export default function NavBar(){
    
    return (
        <div className={`w-full text-3xl font-bold py-3 text-center shadow-nav-light fixed top-0 bg-white
        dark:text-white dark:bg-slate-950 dark:shadow-nav-dark`}>
            <h1>Blog Hub</h1>
        </div>
    );
}